import React from 'react';
import ReactDOM from 'react-dom';
import './assets/stylesheets/index.css';
import App from './App';
import registerServiceWorker from './registerServiceWorker';

const continent = window.document.querySelector('meta[name="geo_continent"]')

ReactDOM.render(<App continent={continent && continent.content}/>, document.getElementById('root'));

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js